import { adminHttpClient } from '../commons/adminHttpClient'
import { RecurringExpenseStatus } from '../../domain/expenses/RecurringExpenseStatus'
import PagedList from '../commons/pagedList'

export type SearchPremiumsFilter = {
  searchValue?: string
  startDate?: string
  lastModifiedAt?: string
  pageNumber: number
  pageSize: number
  orderColumn: string
  orderDescending: boolean
}

export type SearchPremiumResponse = {
  id: string
  expenseNumber: string
  lastModifiedAt: string
  startDate: string
  fullName: string
  companyName: string
  email: string
  status: RecurringExpenseStatus
  amount: number
  attachments: Attachment[]
}

type Attachment = {
  attachmentId: string
  fileNameUrl: string
  title: string
  reuseInOtherExpenses: boolean
}

export const searchPremiums = (request: SearchPremiumsFilter): Promise<PagedList<SearchPremiumResponse>> => {
  return adminHttpClient.get(`/Expenses/SearchPremiums`, request)
}
